import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { BsDryMassesSection, BsMeasurementsSection, BsPreparationSection, BsResultsSection } from './Sections';

const qestIds = [ids.moistureContent.BS_1377_2.rev1990];

const BsMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <BsPreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <BsMeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <PageSection heading="Dry Mass">
      <BsDryMassesSection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <BsResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

BsMoistureContentWorksheet.qestIds = qestIds;

export default BsMoistureContentWorksheet;
export { BsMoistureContentWorksheet };
